import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { PublicApi } from '../constants';
import { AppResponse } from '../constants/ApiResponse';
import {
  Auth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from '@angular/fire/auth';
import { SecureStorageService } from '@services/secure-storage.service';

type PublicApiKeys = keyof typeof PublicApi | 'BILLING_DISCOUNT';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private auth: Auth,
    private secureStorage: SecureStorageService
  ) { }

  login1(username: string, password: string): boolean {
    if (username === 'admin' && password === '123') {
      const token = 'fake-jwt-token'; // Normally you would get this from the server
      void this.secureStorage.setItem('authToken', token);
      void this.secureStorage.setItem('userRole', 'admin'); // Store user role for authorization
      return true;
    } else return false;
  }

  isAuthenticated(): boolean {
    const token = this.secureStorage.getItem('authToken');
    const userDetails = this.getUserDetails();
    if (!token || !userDetails || !userDetails?.verified || !userDetails?.isCompany || userDetails?.isCompany?.length === 0  ) {
      return false;
    }
    return true;
  }

  // Check if user is logged in
  isLoggedIn(): boolean {
    return !!this.secureStorage.getItem('authToken');
  }

  logout1(): void {
    this.secureStorage.removeItem('authToken');
    this.secureStorage.removeItem('userRole');
    this.router.navigate(['auth/login']);
  }

  // Get user role for authorization
  getUserRole(): string | null {
    return this.secureStorage.getItem('userRole');
  }

  getUserEmail(): string | null {
    const userDetails = this.getUserDetails();
    if (userDetails) {
      return userDetails?.email || null;
    }
    return null;
  }
  getUserId(): string | null {
    const userDetails = this.getUserDetails();
    if (userDetails) {
      return userDetails?.id || null;
    }
    return null;
  }

  getAll(endpoint: PublicApiKeys): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .get<AppResponse>(apiUrl)
      .pipe(catchError(this.handleError));
  }
  delete(endpoint: PublicApiKeys): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .delete<AppResponse>(apiUrl)
      .pipe(catchError(this.handleError));
  }
  deletebyId(
    endpoint: PublicApiKeys,
    id: string | number
  ): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .delete<AppResponse>(`${apiUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }
  register(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }
  login(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }
  verify(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }
  logout(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }

  getById(endpoint: PublicApiKeys, id: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = `${PublicApi[endpoint]}/${id}`;
    return this.http
      .get<AppResponse>(apiUrl)
      .pipe(catchError(this.handleError));
  }

 private handleError(error: any): Observable<never> {
  if (error.error instanceof ErrorEvent) {
    // Client-side error
    console.error(`Client-side error: ${error.error.message}`);
  } else {
    // Server-side error
    console.error(`Server-side error: ${error.status} - ${error.message}`);
  }
  
  // ✅ DON'T override the actual error - pass it through
  return throwError(() => error);
}
  setToken(data: any) {
    void this.secureStorage.setItem('authToken', data.user.authToken);
    void this.secureStorage.setItem('jwtToken', data.user.authToken);
    sessionStorage.setItem('jwtToken', data.user.authToken);
    // localStorage.setItem('userRole', data.user._roles.name);
    this.setUserDetails(data);
  }

  setTokenII(data: any) {
    void this.secureStorage.setItem('authToken', data.authToken);
    void this.secureStorage.setItem('jwtToken', data.authToken);
    sessionStorage.setItem('jwtToken', data.authToken);
    // localStorage.setItem('userRole', data.user._roles.name);
    this.setUserDetails(data.data);
  }


  setUserToken(data: any) {
    void this.secureStorage.setItem('userToken', data.user.authToken);
    void this.secureStorage.setItem('jwtToken', data.user.authToken);
    // localStorage.setItem('userRole', data.user._roles.name);
    sessionStorage.setItem('jwtToken', data.user.authToken);
  }

  setUserDetails(data: any) {
    void this.secureStorage.setItem('userDetails', data.user);
  }

  getUserDetails(): any {
    return this.secureStorage.getItem('userDetails');
  }

  signInWithGoogle() {
    return signInWithPopup(this.auth, new GoogleAuthProvider());
  }

  signInWithFacebook() {
    return signInWithPopup(this.auth, new FacebookAuthProvider());
  }
}
